export default function ButtonMessage({ message }) {
  return (
    <>
      <div className="flex w-full items-center justify-center rounded-lg border border-gray-200 bg-white py-1.5 px-2.5 text-center text-sm text-blue-500 shadow-sm hover:bg-gray-100">
        {message.body}
      </div>
    </>
  );
}
